import { useQuery } from 'react-query'
import React from "react";
import { fetchTrialSignUpsExplorer } from "../../api/dashStats"
import { CwbDataExplorer } from "../DataExplorer";

function ByPlanWithRegion({ date }) {
    const fetchData = async () => {
        const { data } = await fetchTrialSignUpsExplorer('byPlanWithRegion', date);
        if (data.result && data.result.data) return data.result;
        return { ...data.result, data: [] }; // Ensure data is always an array
    };

    const { data, error, isError, isLoading } = useQuery(
        ['trialsByRegionAndPlan', date],
        fetchData,
        {
            refetchOnWindowFocus: false,
        }
    );
    const dataProps = { data, error, isError, isLoading };
    return <CwbDataExplorer key={"byRegionAndPlan" + date}  {...dataProps } />
}
export default ByPlanWithRegion